import { useState } from "react";
import { getGamePerformance } from "../api/dashboardApi";
import { getRevenueData } from "../api/dashboardApi";

const useDashboardGraph = () => {
  const [revenueData, setRevenueData] = useState([]);

  const fetchRevenueGraph = async (month, year) => {
    if (!month || !year) return;
    try {
      const res = await getRevenueData(month, year);
      console.log("revenue data:", res);
      return res;
    } catch (error) {
      console.log("error on get revenue data :", error);
    }
  };

  return {
    fetchRevenueGraph,
    revenueData,
  };
};

export default useDashboardGraph;
